// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ee864a53","416":"5b02afc6","538":"7502cfce","545":"363a01e3","566":"8ac7cd68","614":"084c75c7","676":"898b7270"}[chunkId] + ".chunk.js";
};